import { type ReactNode } from 'react';
import { ItemsTable } from 'receivable-invoices-js/react/components/items-table';
import { ReceivableInvoicesActions } from 'receivable-invoices-js/react/components/receivable-invoices/actions';
import { ReceivableInvoicesInformation } from 'receivable-invoices-js/react/components/receivable-invoices/information';
import type { ReceivableInvoice } from 'receivable-invoices-js/react/api/models/receivable-invoice';
import { useMedia } from 'receivable-invoices-js/react/hooks/use-media';
import styles from '../responsive-view.module.css';

interface ReceivableInvoiceContentProps {
  document: ReceivableInvoice;
  downloadAll?: () => Promise<void>;
  hasAttachments?: boolean;
  showPayCTA?: boolean;
}

export function ReceivableInvoiceContent({
  document,
  downloadAll,
  hasAttachments = false,
}: ReceivableInvoiceContentProps): ReactNode {
  const { isMobile } = useMedia();

  return (
    <div className={styles.details} data-testid="receivable-invoice-content">
      <ReceivableInvoicesInformation
        className={styles.information}
        data-testid="receivable-invoice-information"
        invoice={document}
      />
      <ReceivableInvoicesActions
        className={styles.actions}
        data-testid="receivable-invoice-actions"
        downloadAll={downloadAll}
        hasAttachments={hasAttachments}
        hideDownloadButton={!document.pdfUrl}
        invoiceId={document.id}
        invoiceStatus={document.status}
        isImported={Boolean(document.isImported)}
        pdfUrl={document.pdfUrl || ''}
        sddEnabled={document.directDebitEnabled || false}
        showPayCTA={!isMobile}
      />
      <ItemsTable
        className={styles.itemsTable}
        isImported={Boolean(document.isImported)}
        sections={document.sections}
      />
    </div>
  );
}
